import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { status, kycStatus } = payload || {}

    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_RIDERS, {
      queryParams: {
        status,
        kycStatus
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch riders',
        data: null,
      }
    }

    const riders = Array.isArray(raw.data) ? raw.data : (raw.data?.data || [])

    // 1. Formattage de la liste complète
    const formatted = riders.map(r => {
      const firstName = r.profile?.firstName || r.firstName || '';
      const lastName = r.profile?.lastName || r.lastName || '';
      const fullName = (r.name || `${firstName} ${lastName}`).trim() || 'Livreur sans nom';
      // balance vient de l'enrichissement wallet (getWalletBalancesForList)
      const balance = r.balance ?? r.metadata?.wallet?.balance ?? r.wallet?.balance ?? 0;

      // Location from entity: { lat, lon, updatedAt }
      const loc = r.location || r.lastLocation || {}

      return {
        ...r,
        id: String(r.id || ''),
        // riderId = champ enrichi par l'agrégation (metadata.riderId)
        riderId: r.riderId || r.metadata?.riderId || r.id || '',
        name: fullName,
        firstName: firstName,
        lastName: lastName,
        email: r.email || '',
        phoneNumber: r.phone || r.phoneNumber || r.metadata?.phoneNumber || r.profile?.phone || '',
        // Statut réel de connexion : 'online' ou 'offline'
        status: r.status || 'offline',
        accountStatus: r.accountStatus || 'active',
        isSuspended: Boolean(
          r.metadata?.isSuspended ||
          r.metadata?.suspended ||
          r.isSuspended ||
          r.accountStatus === 'suspended'
        ),
        availability: r.availability || (r.status === 'online' ? 'available' : 'unavailable'),
        balance: balance,
        note: r?.avgRating || r.rating || 0,
        // Ces champs viennent directement de getAggregatedRiders (getPlatformStats par rider)
        totalOrdersDelivered: r.totalOrdersDelivered ?? r?.totalDeliveries ?? r?.completedDeliveries ?? 0,
        activeOrders: r.activeOrders ?? (r?.currentDelivery?.id ? 1 : 0),
        totalCommission: r?.totalEarnings || 0,
        kycStatus: r.kycStatus || '',
        // Map tracking : /rider/list retourne lat/lng à la racine ; agrégation dans location
        location: {
          lat: loc.lat ?? r.lat ?? null,
          lng: loc.lon ?? loc.lng ?? r.lng ?? null,
          updatedAt: loc.updatedAt ?? r.lastLocationUpdateDate ?? null,
        },
      };
    })

    // 2. Application du filtre search si présent dans le payload
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()

    const filtered = searchTerm
      ? formatted.filter(r => {
          return (
            r.name.toLowerCase().includes(searchTerm) ||
            r.firstName.toLowerCase().includes(searchTerm) ||
            r.lastName.toLowerCase().includes(searchTerm) ||
            r.email.toLowerCase().includes(searchTerm) ||
            r.phoneNumber.toLowerCase().includes(searchTerm) ||
            r.kycStatus.toLowerCase().includes(searchTerm) ||
            r.id.toLowerCase().includes(searchTerm)
          )
        })
      : formatted

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    let finalData = filtered
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      finalData = [...finalData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = finalData.slice(page * limit, (page + 1) * limit)

    // 3. Retour des données avec le total recalculé dynamiquement
    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: searchTerm ? filtered.length : (raw.total || formatted.length),
        result: paginated,
      },
    }
  },
}